import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import {Inc,Dataset,Owner,Plan,Item} from './Inc';
import ColInput from './ColInput';
import Toast from './Toast';
import RowData from './RowData';
import Ajax from './Ajax';
import Loading from './Loading';
import PlanConfirm from './PlanConfirm';
import Title from './Title';
import StoreImg from './StoreImg';

interface Props {
	owner:Owner,
}

//let errors:string[] = [];

const PlanInput = (props:Props)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();
	const defItems:Item[] = [];
	const defCheckedIds:number[] = [];
	const defDays:Dataset[] = [];
	const [states,setStates] = useState({
		plan: Inc.defaultPlan(),
		items: defItems,
		ngItems: defItems,
		checkedIds: defCheckedIds,
		checkedItems: defItems,
		days:defDays,
		ready: false,
		errorName: "",
		redirectId: 0,
		isLoading: true,
		isConfirm: false,
		allChecked: false,
        errors: [] as string[],
	});
	const [toast,setToast] = useState("");

	const addError = (name:keyof Plan,isError:boolean) =>{
        const errors = [...states.errors];
		if( isError ){
			if( !errors.includes(name) ){
				errors.push( name );
			}
		} else {
			if( errors.includes(name) ){
				const index = errors.findIndex((v) => v===name);
				errors.splice(index,1);
			}
		}
        setStates(prev => ({ ...prev, errors: errors }));
	}

	const change = (name:keyof Plan,value:string)=>{
		setStates({...states,"plan":{...states.plan,[name]:value}});
	}
	const changeSelect = (name: string) => (event: SelectChangeEvent) => {
		//const isError = validate();
		if( name==="plan_hour" || name==="lottery_period" ){
			setStates({...states,"plan":{...states.plan,[name]:parseInt(event.target.value)}});
		} else {
			setStates({...states,"plan":{...states.plan,[name]:event.target.value}});
		}
	};

	const checkId = (index:number)=>{
		const id = states.items[index].item_id;
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index2 = ids.findIndex((v) => v===id);
			ids.splice(index2,1);

			let items = states.checkedItems;
			const index3 = items.findIndex((v) => v.item_id===id);
			items.splice(index3,1);

			setStates({...states,"checkedIds":ids,"checkedItems":items});
		} else {
			const item = states.items[index];
			setStates({...states,"checkedItems":states.checkedItems.concat(item),"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedItems":[],"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.items.length ; i++ ){
				ids.push( states.items[i].item_id );
			}
			setStates({...states,"checkedItems":states.items,"checkedIds":ids,"allChecked":true});
		}
	}


	const confirm = ()=>{
		//console.log("states",states);
		//console.log("errors",errors);
		if( states.checkedIds.length===0 ){
			setToast("商品が選択されていません");
		} else {
			setStates({...states,isConfirm:true});
		}
	}
	const closeToast = ()=>{
		setToast("");
	}

	const send = ()=>{
		setStates({...states,isLoading:true});
		Ajax.send("plan/do",{plan:states.plan,item_ids:states.checkedIds},(res:any)=>{
			//console.log(res);
			if( res.ok ){	   
				setStates({...states,redirectId:1,isLoading:false});
			}
		});
	}
	const closeModal = ()=>{
		setStates({...states,isConfirm:false});
	};

	useEffect( ()=>{
		if( props.owner.owner_id>0 ){
			Ajax.send("plan/items",{},(res:any)=>{
				//console.log(res);
				if( res.ok ){
					let date = "";
					if( res.days[0] ){
						date = res.days[0].id;
					}
					setStates({...states,"isLoading":false,"items":res.items,"ngItems":res.ng_items,"days":res.days,plan:{...states.plan,"plan_date":date}})
				}
			});
		} else {
			setStates({...states,"isLoading":false});
		}
	} ,[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}	

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		)
	}

	if( states.redirectId>0 ){
		return (
			<Redirect to="/plan"/>
		)
	}

	return (
		<div id="profile_input" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={9}>
					<Paper className={classes.paper}>
						<Title text="発売日登録" icon="trending"/>
						<div style={{marginBottom:"2em"}}>
						商品を１つ以上選択し、発売日時と抽選期間を設定して下さい。 <br/>
						</div>
						<Grid container spacing={4}>
							<Grid item xs={12} md={7}>
								<FormControl error={states.checkedIds.length===0} style={{marginBottom:"1.5em"}}>
									<FormLabel component="label" className={classes.formLabel}>商品<span className="formRequired">必須</span>
										<Button variant="outlined" color="primary" size="small" style={{position:'absolute',top:'0',right:'0'}} disabled={states.items.length===0} onClick={checkAllId}>全選択/解除</Button>
									</FormLabel>
									<List>
									{states.items.map((item:Item,index:number)=>{
										const key = "item"+index;
										const v = states.checkedIds.includes(item.item_id);
										return (
											<ListItemButton key={key} style={{margin:'0.5em 0'}} dense onClick={()=>checkId(index)}>
												<ListItemIcon style={{marginLeft:'-1em',marginRight:'-1em'}}>
													<Checkbox
														checked={v}
														value={String(item.item_id)}
														color="primary"
														className={classes.listCheckbox}
													/>
												</ListItemIcon>
												<ListItemAvatar style={{marginRight:'1em'}}><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/></ListItemAvatar>
												<ListItemText primary={(<><span className={classes.itemId}>ID:{item.item_id}</span><br/><span>{item.item_name}</span></>)} secondary=""/>
											</ListItemButton>
										)
									})}
									</List>
									{states.items.length>0 && states.checkedIds.length===0 &&
										<FormHelperText>※一つ以上選択してください</FormHelperText>
									}
									{states.items.length===0 &&
										<FormHelperText>※発売できる商品がありません</FormHelperText>
									}

								</FormControl>
								{states.ngItems.length>0 &&
								<div style={{padding:"1em",fontSize:"80%",marginTop:"3em"}}>
									▼次の商品は画像が未設定のため公開できません。<br/>
									{states.ngItems.map((item:Item,index:number)=>{
										const key = "item"+index;
										//const v = states.checkedIds.includes(item.item_id);
										return (
											<div key={key}>
												<span className={classes.itemId}>ID:{item.item_id}</span>
												<span> {item.item_name}</span>
											</div>
										)
									})}
								</div>
								}
							</Grid>
							<Grid item xs={12} md={5}>
								<Box style={{marginBottom:"1.5em"}}>
									<FormLabel component="label" className={classes.formLabel}>発売日時<span className="formRequired">必須</span></FormLabel>
									<FormGroup row>
										<Select
											value={states.plan.plan_date}
											onChange={changeSelect("plan_date")}
											inputProps={{
												name: "plan_date",
												id: "plan_date",
											}}
											margin="none"
											variant="standard"
											style={{marginTop:"0.3em",width:"65%"}}
										>
											{states.days.map((option:Dataset,index:number) => {
												const key = "option"+index;
												return (
													<MenuItem key={key} value={option.id}>
														{option.label}
													</MenuItem>
												)
											})}
										</Select>
										<Select
											value={String(states.plan.plan_hour)}
											onChange={changeSelect("plan_hour")}
											inputProps={{
												name: "plan_hour",
												id: "plan_hour",
											}}
											margin="none"
											variant="standard"
											style={{marginTop:"0.3em",width:"35%"}}
										>
											{Inc.planHours.map((option:Dataset,index:number) => {
												const key = "option"+index;
												return (
													<MenuItem key={key} value={option.id}>
														{option.label}
													</MenuItem>
												)
											})}
										</Select>
									</FormGroup>
									<div style={{marginTop:"1em",marginBottom:"2em",fontSize:"90%",padding:"0.5em",backgroundColor:"#EEEEEE"}}>
										・設定できる発売日は明日以降１週間後までです。<br/>
										・年末年始や臨時休業の日は選択できない場合があります。<br/>
									</div>
								</Box>
								<ColInput name="抽選期間" value={String(states.plan.lottery_period)} addError={addError} change={change} id="lottery_period" type="select" list={Inc.lotteryPeriods} required/>
								<div style={{marginTop:"-0.5em",marginBottom:"3em",fontSize:"90%",padding:"0.5em",backgroundColor:"#EEEEEE"}}>
									・抽選販売の詳細はヘルプ！の「抽選販売」をご覧ください。<br/>
									・電子書籍戯曲は抽選期間の設定に関わらず抽選を行いません。<br/>
								</div>
								<ColInput name="先行販売キー" value={String(states.plan.prior_flag)} addError={addError} change={change} id="prior_flag" type="select" list={Inc.uses} required/>
								<div style={{marginTop:"-0.5em",marginBottom:"3em",fontSize:"90%",padding:"0.5em",backgroundColor:"#EEEEEE"}}>
									・先行販売の詳細はヘルプ！の「先行販売」をご覧ください。
								</div>
							</Grid>
						</Grid>

						<Hidden mdUp implementation="js">
							<Divider style={{margin:"1em 0"}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12}>
									<FormControl fullWidth={true}>
										<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.checkedIds.length===0}>この内容で登録する</Button></Badge>
									</FormControl>
								</Grid>
								<Grid item xs={12} lg={12}>
									<Link to="/plan"><Button variant="outlined" style={{width:"100%"}}>登録しないで中断する</Button></Link>
								</Grid>
							</Grid>
							<ul className={classes.guideUl}>
								<li className={classes.guideLi}>発売日を設定できるのは状態表示が「非公開」または「在庫なし」の商品だけです。</li>
								<li className={classes.guideLi}>発売日とシークレットは同時に設定できません。</li>
							</ul>
						</Hidden>

					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					<Paper className={classes.paper}>
						<Title text="管理情報" size={2}/>
						<RowData name="発売可能商品数" value={String(states.items.length)} width="60%"/>
						<RowData name="画像未設定" value={String(states.ngItems.length)} width="60%"/>

						<Hidden smDown implementation="js">
							<Divider style={{margin:"1em 0"}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12}>
									<FormControl fullWidth={true}>
										<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.checkedIds.length===0}>この内容で登録する</Button></Badge>
									</FormControl>
								</Grid>
								<Grid item xs={12} lg={12}>
									<Link to="/plan"><Button variant="outlined" style={{width:"100%"}}>登録しないで中断する</Button></Link>
								</Grid>
							</Grid>
							<ul className={classes.guideUl}>
								<li className={classes.guideLi}>発売日を設定できるのは状態表示が「非公開」または「在庫なし」の商品だけです。</li>
								<li className={classes.guideLi}>発売日とシークレットは同時に設定できません。</li>
							</ul>
						</Hidden>
					</Paper>
				</Grid>
			</Grid>
			<PlanConfirm send={send} isOpen={states.isConfirm} close={closeModal} owner={props.owner} plan={states.plan} items={states.checkedItems} days={states.days}/>
			<Toast close={closeToast} mes={toast}/>
		</div>
	);
}

export default PlanInput;
